import React from "react";
import { NavLink } from "react-router-dom";
import { gqlType } from "@hifieng/common";

import ListDetailsSection from "../../ListDetailsSection";
import EventMap from "../../EventMap";
import { Primary as PrimaryButton } from "../../Button";
import TrainRun from "../TrainRun/Active";

import { useActiveTrains } from "./useActiveTrains";
import { ITabContent } from "../../TabbedContent";

interface IActiveTrainsTabContent extends ITabContent {
  emptyUrl: string;
  hideEmptyCta?: boolean;
}

const ActiveRuns = ({
  emptyUrl,
  hideEmptyCta,
  onActivated
}: IActiveTrainsTabContent) => {
  const { trainRuns, loading } = useActiveTrains();

  const sortedRuns: Array<gqlType.TrainRun> = trainRuns
    ? trainRuns.trains.sort(
        (a: gqlType.TrainRun, b: gqlType.TrainRun) =>
          b.latest.timestamp - a.latest.timestamp
      )
    : undefined;

  if (!sortedRuns) return null;

  if (onActivated) onActivated({ title: "active" });

  return (
    <ListDetailsSection
      emptyStateText="No Trains Detected"
      emptyCta={
        !hideEmptyCta && (
          <NavLink to={emptyUrl}>
            <PrimaryButton component="div">View Completed Runs</PrimaryButton>
          </NavLink>
        )
      }
      emptyDescription={`There are currently no active trains in\n the pipelines displayed.`}
      totalEvents={sortedRuns.length}
      loading={loading}
      paginate={false}
      listComponent={
        <>
          {sortedRuns.map(run => (
            <TrainRun trainRun={run} key={run.id} />
          ))}
        </>
      }
      mapComponent={
        <EventMap
          canSearchOnMapMove={false}
          events={sortedRuns || []}
          trainMode
          scrollZoom
        />
      }
    />
  );
};

export default ActiveRuns;
